import {
  BrandAndMarketListItem,
  Carriers,
  CodeAndLabel,
  FareBasisCode, GuidIdCodeAndLabel, Int32IdAndLabel, StationOrLocationItem,
} from '../../../integrated-client';
import {DEFAULT_LIMIT} from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  showDisabled: boolean;
  brandAndMarket: BrandAndMarketListItem | null
  distributionChannel: Int32IdAndLabel | null;
  agency: GuidIdCodeAndLabel | null;
  description: string | null;
  relevance: number | null;
  origin: StationOrLocationItem | null;
  originIsCityCode: boolean | null;
  destination: StationOrLocationItem | null;
  destinationIsCityCode: boolean | null;
  marketingFlightNumbers: string | null;
  fareBasis?: FareBasisCode;
  fareType?: CodeAndLabel;
  carriers?: Carriers;
  bookingClass: string | null;
  showDeleted?: boolean;
  orderByRelevanceAscending?: boolean
  offset: number | null;
  limit: number | null;
  total: number
  currentPage: number
}

export class FormData implements IFormData{

  showDisabled: boolean;
  brandAndMarket: BrandAndMarketListItem | null
  distributionChannel: Int32IdAndLabel | null;
  agency: GuidIdCodeAndLabel | null;
  description: string | null;
  relevance: number | null;
  origin: StationOrLocationItem | null;
  originIsCityCode: boolean | null;
  destination: StationOrLocationItem | null;
  destinationIsCityCode: boolean | null;
  marketingFlightNumbers: string | null;
  fareBasis?: FareBasisCode;
  fareType?: CodeAndLabel;
  carriers?: Carriers;
  bookingClass: string | null;
  showDeleted?: boolean;
  orderByRelevanceAscending?: boolean
  offset: number | null;
  limit: number | null;
  total: number
  currentPage: number

  constructor() {
    this.showDisabled = false
    this.brandAndMarket = null
    this.distributionChannel = null
    this.agency = null
    this.description = null
    this.relevance = null
    this.origin = null
    this.originIsCityCode = null
    this.destination = null
    this.destinationIsCityCode = null
    this.marketingFlightNumbers = null
    this.bookingClass = null
    this.showDeleted = false
    this.offset = 0
    this.limit = DEFAULT_LIMIT
    this.total = DEFAULT_TOTAL_ITEMS
    this.currentPage = 1
  }
}
